import { render } from "./exchange_huobi.vue?vue&type=template&id=66e6fab4&scoped=true"
import script from "./exchange_huobi.vue?vue&type=script&lang=js"
export * from "./exchange_huobi.vue?vue&type=script&lang=js"

import "./exchange_huobi.vue?vue&type=style&index=0&id=66e6fab4&lang=css&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e6fab4"]])

export default __exports__